export const pathRoutes = [
    {
      id: 1,
      name: 'Inicio',
      path: '/'
    },
    {
      id: 2,
      name:  'Destinos',
      path: '/destinos'
    },
    {
      id: 3,
      name: 'Servicios',
      path: '/servicios'
    },
    {
      id: 4,
      name: 'Encomiendas',
      path: '/encomiendas'
    },
    {
      id: 5,
      name: 'Promociones',
      path: '/promociones'
    },
    {
      id: 6,
      name: 'Contáctanos',
      path: '/contactanos'
    },
];